export default function (state, data) {
  state.Number = data.Number;
  state.IssueDate = data.IssueDate.Serialized;
  state.StartDate = data.StartDate.Serialized;
  state.EndDate = data.EndDate.Serialized;
  state.ContragentId = '';
  state.PartnerLegalId = '';
  state.ContragentName = '';
  state.ContragentType = '';
  state.OwnerLegalEntityId = data.OwnerLegalEntityId;
  state.CurrencyId = data.CurrencyId;
  state.Type = data.Type;
  state.IsPayed = data.IsPayed;
  state.IsUsed = data.IsUsed;
  state.Sum = data.Sum;
  if (data.CreateDate && data.CreateDate.Serialized) state.CreateDate = data.CreateDate.Serialized;
  state.CreatorName = data.CreatorName;

  if (data.ClientId) {
    state.ContragentId = data.ClientId;
    state.ContragentName = data.ClientName;
    state.ContragentType = 1;
  }
  if (data.PartnerId) {
    state.ContragentId = data.PartnerId;
    state.ContragentName = data.PartnerName;
    state.ContragentType = 2;
    state.PartnerLegalId = data.PartnerLegalId ? data.PartnerLegalId : '';
  }
  if (data.OwnerId) {
    state.IsOwner = true;
    state.OwnerId = data.OwnerId;
    state.OwnerName = data.OwnerName;
  }else{
    state.IsOwner = false;
    state.OwnerId = '';
    state.OwnerName = '';
  }

  if(!data.Comment) {
    data.Comment = ''
  }
  state.Comment = data.Comment;
}
